/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// redux
import {useSelector, useDispatch} from "react-redux";
import {updateCachedAccountRevenueShare} from "../../../../../state/slices/settings";
// material
import SectionGroupDescription
  from "../../../../../material/expandablesection/sectiongroupdescription/sectiongroupdescription";
import {ListTable} from "@insticator/insticator-ui";
import SectionCard from "../../../../../material/expandablesection/sectioncard/sectioncard";
import SectionGroup from "../../../../../material/expandablesection/sectiongroup/sectiongroup";
import InputForm from "../../../../../material/inputform/inputForm";
// utils
import {preventPasteNegative, preventSymbols} from "./utils/functions";
// consts
import {REVSHARE_COL_HEADS} from "../billing_const";
import {REVENUE_TYPES} from "../../../../../utils/consts";
// styles
import injectSheet from "react-jss";
import styles from './advanced_styles';

/* ========== ~~~~~~~~~~ SUBSCRIPTIONS ~~~~~~~~~~ ========== */
const Subscriptions = injectSheet(styles)((props) => {
  const dispatch = useDispatch()
  const revenueShare = useSelector((state) => state.settings.revenueShare)

  const handleRevShareChange = (e, index) => {
    let val = e.target.value

    val = (val.indexOf(".") >= 0)
      ? (val.substr(0, val.indexOf(".")) + val.substr(val.indexOf("."), 3))
      : val;
    if (val > 100) {
      return
    }

    const revShareType = e.target.name.split('.')[1]
    dispatch(updateCachedAccountRevenueShare({index, revShareType, val}))
  }

  const formattedRevShare = revenueShare.map((revShare, index) => ({
    products: REVENUE_TYPES[revShare.type],
    defaultInitialLoadRevShare: <InputForm name={revShare.type + ".initialLoadRevenueSharePercentage"}
                                           value={revShare.initialLoadRevenueSharePercentage}
                                           isNumber={true}
                                           handleChange={e => handleRevShareChange(e, index)}
                                           handlePaste={preventPasteNegative}
                                           handleKeyPress={preventSymbols}/>,
    defaultRefreshRevShare: <InputForm name={revShare.type + ".refreshRevenueSharePercentage"}
                                       value={revShare.refreshRevenueSharePercentage}
                                       isNumber={true}
                                       handleChange={e => handleRevShareChange(e, index)}
                                       handlePaste={preventPasteNegative}
                                       handleKeyPress={preventSymbols} />
  }));

  return (
    <SectionCard>
      <SectionGroup>
        <SectionGroupDescription title='Subscriptions'/>
        <div className="table">
          <ListTable
            columnHeads={REVSHARE_COL_HEADS}
            data={formattedRevShare}
            size={'full'}
          />
        </div>
      </SectionGroup>
    </SectionCard>
  )
})

export default Subscriptions;